import React from "react";

const LOGO_URL = "/images/brand-logo.webp";

// Zuerich Airport Taxi wordmark logo.
export const BrandLogo = ({ size = "md", className = "", testId = "brand-logo" }) => {
  const h = size === "sm" ? "h-12" : "h-16 md:h-20";
  return (
    <span className={`inline-flex items-center select-none ${className}`} data-testid={testId}>
      <img src={LOGO_URL} alt="Zuerich Airport Taxi" width="632" height="171" fetchPriority="high" className={`${h} w-auto object-contain`} />
    </span>
  );
};

export default BrandLogo;
